/**
 * Returns the position ("Lower Third", "Middle Third", "Upper Third") for a given data object.
 * @param {Object} dataObj - The data object (e.g., graph.data[0])
 * @returns {string} - "Lower Third", "Middle Third", or "Upper Third"
 */
export default function getThirdPosition(dataObj) {
  const lower = Number(dataObj.lowerThird);
  const middle = Number(dataObj.middleThird);
  const user = Number(dataObj.user);
  //console.log("getThirdPosition dataObj: ", user, lower, middle, lower + middle);
  if (user < lower) return "LOWERTHIRD";
  if (user < (lower + middle)) return "MIDDLETHIRD";
  return "UPPERTHIRD";
}